/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractRestService, file, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';

@Injectable()
export class MobileQrCodeDialogRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  getQRCode(): Observable<Blob> {
    return this.httpGet(`${this.bp}/mobile-app/qrcode/ios`, {}, void 0, file());
  }
}
